<template>

  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-1 my-3">
            Discussion Forum
          </h4>
          <span class="subheading">
            <p>This Challenge has an external discussion forum, where you can ask questions, share ideas, and engage with admins and other solvers.</p>
          </span>
          <v-divider class="my-3"></v-divider>

          <!-- <div class="title my-4">Go to discussion forum</div> -->
          <!-- <v-btn v-on:click="linkOut" large color="primary" dark class="mx-0">Go to discussion form</v-btn> -->
          <v-btn href="https://gitter.im/DIUx-xView/Lobby" large color="primary" dark class="mx-0">Go to discussion forum</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  // import firebase from 'firebase'

  export default {
    name: 'Discussion',
    data () {
      return {
      }
    },

    methods: {
      linkOut: function (event) {
        console.log('Leaving challenge app, going to Discussion forum...')
        this.$router.push({ path: 'https://gitter.im/DIUx-xView/Lobby' })
      }
    },

    mounted () {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Discussion.vue